import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { routes } from "../storage/constants/routes";
import logo from "../images/logo.png";
import classes from "../styles/components/header.module.scss";
import elements from "../styles/settings/elements.module.scss";

function HomePage() {
    return (
        <Container className={classes.header}>
            <Row className="align-items-center">
                {/* Left: Logo */}
                <Col xl={4} lg={4} md={3} sm={3} xs={3}>
                    <NavLink to={routes.home}>
                        <img src={logo} alt="Logo" className={classes.logo} />
                    </NavLink>
                </Col>
                {/* Center: Navigation Links */}
                <Col xl={4} lg={4} md={6} sm={6} xs={6} className={classes.links}>
                    <NavLink to={routes.apps} className={classes.link}>
                        <span>Apps</span>
                    </NavLink>
                    <NavLink to={routes.games} className={classes.link}>
                        <span>Games</span>
                    </NavLink>
                </Col>
                {/* Right: Buttons */}
                <Col xl={4} lg={4} md={3} sm={3} xs={3} className={classes.buttons}>
                    {/*<NavLink to={routes.apps}>*/}
                    {/*    <Button className={`${elements.button} ${classes.button}`}>Log in</Button>*/}
                    {/*</NavLink>*/}
                    {/*<NavLink to={routes.apps} className={'d-none d-lg-inline-block d-xl-inline-block'}>*/}
                    {/*    <Button className={elements.button}>Sign up</Button>*/}
                    {/*</NavLink>*/}
                </Col>
            </Row>
        </Container>
    );
}

export default HomePage;